const menus = [
  {
    grade_id: 1,
    semesters: [
      {
        semester: 1,
        name: '小学一年级-上学期',
        suffix: 'zip',
        url: 'course/annex-zip/小学一年级-上学期.zip',
      },
      {
        semester: 2,
        name: '小学一年级-下学期',
        suffix: 'zip',
        url: 'course/annex-zip/小学一年级-下学期.zip',
      },
    ],
  },
  {
    grade_id: 2,
    semesters: [
      {
        semester: 1,
        name: '小学二年级-上学期',
        suffix: 'zip',
        url: 'course/annex-zip/小学二年级-上学期.zip',
      },
      {
        semester: 2,
        name: '小学二年级-下学期',
        suffix: 'zip',
        url: 'course/annex-zip/小学二年级-下学期.zip',
      },
    ],
  },
  {
    grade_id: 4,
    semesters: [
      {
        semester: 1,
        name: '小学三年级-上学期',
        suffix: 'zip',
        url: 'course/annex-zip/小学三年级-上学期.zip',
      },
      {
        semester: 2,
        name: '小学三年级-下学期',
        suffix: 'zip',
        url: 'course/annex-zip/小学三年级-下学期.zip',
      },
    ],
  },
  {
    grade_id: 3,
    semesters: [
      {
        semester: 1,
        name: '小学四年级-上学期',
        suffix: 'zip',
        url: 'course/annex-zip/小学四年级-上学期.zip',
      },
      {
        semester: 2,
        name: '小学四年级-下学期',
        suffix: 'zip',
        url: 'course/annex-zip/小学四年级-下学期.zip',
      },
    ],
  },
  {
    grade_id: 5,
    semesters: [
      {
        semester: 1,
        name: '小学五年级-上学期',
        suffix: 'zip',
        url: 'course/annex-zip/小学五年级-上学期.zip',
      },
      {
        semester: 2,
        name: '小学五年级-下学期',
        suffix: 'zip',
        url: 'course/annex-zip/小学五年级-下学期.zip',
      },
    ],
  },
  {
    grade_id: 6,
    semesters: [
      {
        semester: 1,
        name: '小学六年级-上学期',
        suffix: 'zip',
        url: 'course/annex-zip/小学六年级-上学期.zip',
      },
      {
        semester: 2,
        name: '小学六年级-下学期',
        suffix: 'zip',
        url: 'course/annex-zip/小学六年级-下学期.zip',
      },
    ],
  },
  {
    grade_id: 7,
    semesters: [
      {
        semester: 1,
        name: '初中一年级-上学期',
        suffix: 'zip',
        url: 'course/annex-zip/初中一年级-上学期.zip',
      },
      {
        semester: 2,
        name: '初中一年级-下学期',
        suffix: 'zip',
        url: 'course/annex-zip/初中一年级-下学期.zip',
      },
    ],
  },
  {
    grade_id: 8,
    semesters: [
      {
        semester: 1,
        name: '初中二年级-上学期',
        suffix: 'zip',
        url: 'course/annex-zip/初中二年级-上学期.zip',
      },
      {
        semester: 2,
        name: '初中二年级-下学期',
        suffix: 'zip',
        url: 'course/annex-zip/初中二年级-下学期.zip',
      },
    ],
  },
  {
    grade_id: 12,
    semesters: [
      {
        semester: 0,
        name: '高中一年级-前置课程',
        suffix: 'zip',
        url: 'course/annex-zip/高中一年级-前置课程.zip',
      },
      {
        semester: 1,
        name: '高中一年级-上学期',
        suffix: 'zip',
        url: 'course/annex-zip/高中一年级-上学期.zip',
      },
      {
        semester: 2,
        name: '高中一年级-下学期',
        suffix: 'zip',
        url: 'course/annex-zip/高中一年级-下学期.zip',
      },
    ],
  },
  {
    grade_id: 15,
    semesters: [
      {
        semester: 1,
        name: '幼儿园小班-上学期',
        suffix: 'zip',
        url: 'course/annex-zip/幼儿园小班-上学期.zip',
      },
    ],
  },
  {
    grade_id: 16,
    semesters: [
      {
        semester: 1,
        name: '幼儿园中班-上学期',
        suffix: 'zip',
        url: 'course/annex-zip/幼儿园中班-上学期.zip',
      },
      {
        semester: 2,
        name: '幼儿园中班-下学期',
        suffix: 'zip',
        url: 'course/annex-zip/幼儿园中班-下学期.zip',
      },
    ],
  },
  {
    grade_id: 17,
    semesters: [
      {
        semester: 1,
        name: '幼儿园大班-上学期',
        suffix: 'zip',
        url: 'course/annex-zip/幼儿园大班-上学期.zip',
      },
      {
        semester: 2,
        name: '幼儿园大班-下学期',
        suffix: 'zip',
        url: 'course/annex-zip/幼儿园大班-下学期.zip',
      },
    ],
  },
  {
    grade_id: 18,
    semesters: [
      {
        semester: 1,
        name: '小学一年级-上学期',
        suffix: 'zip',
        url: 'course/annex-zip/小学一年级-上学期.zip',
      },
      {
        semester: 2,
        name: '小学一年级-下学期',
        suffix: 'zip',
        url: 'course/annex-zip/小学一年级-下学期.zip',
      },
    ],
  },
  {
    grade_id: 19,
    semesters: [
      {
        semester: 1,
        name: '小学二年级-上学期',
        suffix: 'zip',
        url: 'course/annex-zip/小学二年级-上学期.zip',
      },
      {
        semester: 2,
        name: '小学二年级-下学期',
        suffix: 'zip',
        url: 'course/annex-zip/小学二年级-下学期.zip',
      },
    ],
  },
  {
    grade_id: 22,
    semesters: [
      {
        semester: 1,
        name: '人工智能和自动驾驶',
        suffix: 'zip',
        url: 'course/annex-zip/人工智能和自动驾驶.zip',
      },
    ],
  },
  {
    grade_id: 23,
    semesters: [
      {
        semester: 1,
        name: '人工智能技术及应用',
        suffix: 'zip',
        url: 'course/annex-zip/人工智能技术及应用.zip',
      },
    ],
  },
]

export default menus
